import { IconButton, Switch } from '@mui/material';
import { SubmitButton as Button } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import { selectCustomStyles } from 'components/common/Select';
import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { AsyncPaginate } from 'react-select-async-paginate';
import { fetchLanguages } from 'slices/languageSlice';

const EstimateDurationsForm = ({ item }) => {
    const dispatch = useDispatch()
    const { control, formState: { errors }, getValues, watch, setValue } = useFormContext();
    const [languageState, setLanguageState] = useState([{
        label: "",
        value: ""
    }])
    const [dynamicArray, setDynamicArray] = useState();



    const filteredLanguagesLoadOptions = async (inputValue, loadedOptions, { page }) => {
        const result = await dispatch(fetchLanguages(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
        return {
            options: result.data.map(language => ({
                value: language.id,
                label: language.name,
            })),
            hasMore: page !== result?.last_page,
            additional: {
                page: page + 1,
            },
        };
    };
    useEffect(()=>{
        setDynamicArray(watch("minDurations"))
    }, [watch("minDurations")])

    // const dynamicArray = useMemo(() => {
    //     return watch("minDurations") || [];
    // }, [watch("minDurations")]);
    

    const handleAdd = React.useCallback(() => {
        const newVariants = [...dynamicArray];
        newVariants.push({
            id: newVariants.length + 1,
            min_duration: 15,
            language_id: [],
            start_time: moment(new Date, ["h:mm A"]).format("HH:mm"),
            end_time: moment(new Date, ["h:mm A"]).add(15, "minutes").format("HH:mm"),
        });
        setValue("minDurations", newVariants);
    }, [control, dynamicArray])

    const handleRemove = React.useCallback((index) => {
        const newVariants = [...dynamicArray];
        newVariants.splice(index, 1);
        setValue("minDurations", newVariants);
    }, [dynamicArray])

    useEffect(() => {
        if (item?.min_durations?.length) {
            const formattedDurations = item.min_durations.map((duration) => ({
                id: duration.id,
                min_duration: duration.min_duration,
                start_time: duration.start_time,
                end_time: duration.end_time,
                language_id: {
                    value: duration.language.id,
                    label: duration.language.name
                }
            }));
            setValue('minDurations', formattedDurations);
            const languagesArray = item.min_durations.map((duration) => ({
                value: duration.language.id,
                label: duration.language.name
            }));

            setLanguageState(languagesArray);

        }
    }, [item, setValue]);

    return (
        <div>

            <div className="row-primary row-r justify-content-between flex-row">
                <h2></h2>
                <Button
                    btnText='Add'
                    buttonType='button'
                    handleSubmit={handleAdd}
                />
            </div>


            {
                dynamicArray?.map((field, index) => {
                    return (
                        <div className='est_row_wrapper' key={index}>

                            <div className="row-primary">
                                <h2>Minimum Duration*</h2>
                                <div style={{ width: "100%" }}>
                                    <Controller
                                        name={`minDurations.${index}.min_duration`}
                                        control={control}
                                        rules={{
                                            required: "Please enter minimum duration"
                                        }}
                                        render={({ field }) => (
                                            <input className="input-in type_inp"
                                                type="number"
                                                name='minDurations.min_duration'
                                                placeholder='Name' required
                                                // value={field.value}
                                                {...field}

                                            />
                                        )}
                                    />
                                    {
                                        errors?.minDurations?.length && errors?.minDurations[index]?.min_duration?.message &&
                                        <div style={{ marginBottom: 10 }}>
                                            <ErrorMessage text={errors?.minDurations[index]?.min_duration?.message} />
                                        </div>
                                    }

                                </div>
                            </div>


                            <div className="row-primary">
                                <h2>Language *</h2>
                                <Controller
                                    name={`minDurations.${index}.language_id`}
                                    control={control}
                                    rules={{
                                        required: "Please select a language"
                                    }}
                                    render={({ field }) =>
                                        <div style={{ width: "100%" }}>
                                            <AsyncPaginate
                                                menuPlacement='auto'
                                                styles={selectCustomStyles}
                                                value={field.value}
                                                loadOptions={filteredLanguagesLoadOptions}
                                                isClearable
                                                escapeClearsValue
                                                onChange={(obj) => {
                                                    // setLanguageState(obj)
                                                    field.onChange(obj);
                                                }}
                                                additional={{
                                                    page: 1,
                                                }}
                                            />
                                            {
                                                errors?.minDurations?.length && errors?.minDurations[index]?.language_id?.message &&
                                                <div style={{ marginBottom: 10 }}>
                                                    <ErrorMessage text={errors?.minDurations[index]?.language_id?.message} />
                                                </div>
                                            }
                                        </div>
                                    }
                                />
                            </div>

                            <div className="row-primary">
                                <h2>Start Time*</h2>
                                <div className="time">
                                    <Controller
                                        name={`minDurations.${index}.start_time`}
                                        control={control}
                                        rules={{
                                            required: "Please select start time"
                                        }}
                                        render={({ field }) =>
                                            <div style={{ width: "100%" }}>
                                                <div className="input-image">
                                                    <input
                                                        type="time"
                                                        name='start_time'
                                                        placeholder='hh:mm'
                                                        {...field}
                                                        value={moment(field.value, ["h:mm A"]).format("HH:mm")}
                                                        // value={field.value}
                                                        required
                                                    />
                                                    <img src="/images/clock.png" alt="Clock Icon" className="custom-icon" />
                                                </div>

                                                {
                                                    errors?.minDurations?.length && errors?.minDurations[index]?.start_time?.message &&
                                                    <div style={{ marginBottom: 10 }}>
                                                        <ErrorMessage text={errors?.minDurations[index]?.start_time?.message} />
                                                    </div>
                                                }

                                            </div>
                                        }
                                    />
                                </div>
                            </div>

                            <div className="row-primary">
                                <h2>End Time*</h2>
                                <div className="time">
                                    <Controller
                                        name={`minDurations.${index}.end_time`}
                                        control={control}
                                        rules={{
                                            required: "Please select End time"
                                        }}
                                        render={({ field }) =>
                                            <div style={{ width: "100%" }}>
                                                <div className="input-image">
                                                    <input
                                                        type="time"
                                                        name='field.end_time'
                                                        placeholder='hh:mm'
                                                        {...field}
                                                        value={moment(field.value, ["h:mm A"]).format("HH:mm")}
                                                        // value={field.value}
                                                        required
                                                    />
                                                    <img src="/images/clock.png" alt="Clock Icon" className="custom-icon" />
                                                </div>
                                                {
                                                    errors?.minDurations?.length && errors?.minDurations[index]?.end_time?.message &&
                                                    <div style={{ marginBottom: 10 }}>
                                                        <ErrorMessage text={errors?.minDurations[index]?.end_time?.message} />
                                                    </div>
                                                }
                                            </div>
                                        }
                                    />
                                </div>
                            </div>

                            {dynamicArray?.length > 1 && (
                                <IconButton className="" color='error'
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        marginLeft: "auto",

                                    }}
                                    onClick={() => handleRemove(index)}
                                >
                                    <i className="fa-solid fa-trash-can trash_icon"></i>
                                </IconButton>
                            )}
                        </div>
                    )
                })
            }


        </div>
    )
};

const EstimateDurations = ({ item }) => {
    const { control, formState: { errors }, getValues, watch, setValue } = useFormContext({
        defaultValues: {
            est_duration: 1
        }
    })

    return (
        <>
            <hr />
            <EstimateDurationsForm item={item} />
            <hr />
        </>
    )
}


export default EstimateDurations